export const CLIENT = {
  CLIENT: 'CLIENT',
  GET_CLIENTS: 'GET_CLIENTS',
  INDIVIDUAL_CLIENT: 'INDIVIDUAL_CLIENT',
  COMPANY_CLIENT: 'COMPANY_CLIENT',
};
